import { useState } from 'react';

const SWIPE_CONFIDENCE_THRESHOLD = 10000;

const swipePower = (offset, velocity) => Math.abs(offset) * velocity;

// Carousel navigation state: current index, slide direction, pagination and swipe handling
const useCarousel = (imagesLength) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);

  const paginate = (newDirection) => {
    setDirection(newDirection);
    setCurrentIndex((prevIndex) => {
      let nextIndex = prevIndex + newDirection;
      if (nextIndex < 0) nextIndex = imagesLength - 1;
      if (nextIndex >= imagesLength) nextIndex = 0;
      return nextIndex;
    });
  };

  const goToIndex = (index) => {
    setDirection(index > currentIndex ? 1 : -1);
    setCurrentIndex(index);
  };

  const handleDragEnd = (e, { offset, velocity }) => {
    const swipe = swipePower(offset.x, velocity.x);
    if (swipe < -SWIPE_CONFIDENCE_THRESHOLD) {
      paginate(1);
    } else if (swipe > SWIPE_CONFIDENCE_THRESHOLD) {
      paginate(-1);
    }
  };

  return { currentIndex, setCurrentIndex, direction, paginate, goToIndex, handleDragEnd };
};

export default useCarousel;
